export const EmailIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3332 5.94922V14.2826C18.3332 14.8351 18.1137 15.365 17.723 15.7557C17.3323 16.1464 16.8024 16.3659 16.2498 16.3659H3.74984C3.1973 16.3659 2.6674 16.1464 2.2767 15.7557C1.886 15.365 1.6665 14.8351 1.6665 14.2826V5.94922"
        stroke="white"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3332 5.95052C18.3332 5.39799 18.1137 4.86808 17.723 4.47738C17.3323 4.08668 16.8024 3.86719 16.2498 3.86719H3.74984C3.1973 3.86719 2.6674 4.08668 2.2767 4.47738C1.886 4.86808 1.6665 5.39799 1.6665 5.95052L8.89567 10.4644C9.22678 10.6714 9.60938 10.7811 9.99984 10.7811C10.3903 10.7811 10.7729 10.6714 11.104 10.4644L18.3332 5.95052Z"
        stroke="white"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
